import { z } from "zod";

export enum ReferralAuthorizationDetailsAction {
  CONTINUE = "continue",
  REQUEST = "request",
}

export const referralAuthorizationDetailsSchema = z
  .object({
    authorizationNumber: z.string().trim().min(1),
    startDate: z.iso.date(),
    endDate: z.iso.date(),
    numberOfServices: z.number().int().positive(),
  })
  .refine(({ startDate, endDate }) => startDate <= endDate, {
    message: "End date must be on or after the start date",
    path: ["endDate"],
  });

export const referralAuthorizationDraftSchema = z.object({
  authorizationNumber: z.string().trim().min(1).nullable(),
  startDate: z.iso.date().nullable(),
  endDate: z.iso.date().nullable(),
  numberOfServices: z.number().int().positive().nullable(),
});

export type ReferralAuthorizationDetails = z.infer<typeof referralAuthorizationDetailsSchema>;
export type ReferralAuthorizationDraft = z.infer<typeof referralAuthorizationDraftSchema>;

export const referralAuthorizationDetailsAnswerSchema = z.discriminatedUnion("action", [
  z.object({
    action: z.literal(ReferralAuthorizationDetailsAction.CONTINUE),
    authorization: referralAuthorizationDetailsSchema,
  }),
  z.object({
    action: z.literal(ReferralAuthorizationDetailsAction.REQUEST),
    authorization: referralAuthorizationDraftSchema,
  }),
]);

export type ReferralAuthorizationDetailsAnswer = z.infer<typeof referralAuthorizationDetailsAnswerSchema>;
